import axios from 'axios';
import authHeader from './auth-header';

//const API_URL = 'http://localhost:8080/matrix-mlm/api/mlm/mmlm/';
const API_URL = 'https://www.edibleherbsstores.com/api/mlm/mmlm/';

class ChangeMembersPasswordsService {
  
  resetMembersPasswords() {
    return axios.get(API_URL + `users/resetpasswords`, { headers: authHeader() });
  }

  changeMembsPasswords(username, user) {
    return axios.put(API_URL + `users/resetpasswords/${username}`, {
      staffNo: user.staffNo,
      firstName: user.firstName,
      lastName: user.lastName,
      username: user.username,
      email: user.email,
      password: user.password,
      userType: user.userType
    }, { headers: authHeader() });
  }

}

export default new ChangeMembersPasswordsService();